// extracted by mini-css-extract-plugin
module.exports = {"formBox":"FormSection_formBox__IeI4w","contentBox":"FormSection_contentBox__YQmHR","mainWrapper":"FormSection_mainWrapper__mugvc"};